// external imports
import React, { Fragment } from 'react'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import styled, { css } from 'styled-components'
// helpers
import { up, addResponsivity } from '../lib/styles'
import { extractNodes, extractNodesFromData } from '../lib/helpers'
import injectIntl from '../lib/intl/injectIntl'

// components
import SEO from '../components/SEO'
import {
  Page,
  PageContent,
  Title,
  Gap,
  Row,
  Col,
  Link,
  Text,
  RH,
  Button,
  HeaderBar,
  PeopleList,
  Line,
  SubHeaderBar,
} from '../components'
import T from '../lib/intl/T'

import headerBarImageSrc from '../data/images/about-top.png'

import coop1Src from '../data/images/about-page/dys-centrum.png'
import coop2Src from '../data/images/about-page/charlie.png'
import coop3Src from '../data/images/about-page/centrum-rozumu.png'
import coop4Src from '../data/images/about-page/myslenie-new.jpg'
import coop5Src from '../data/images/about-page/atc.png'

import partner1Src from '../data/images/about-page/cs/prague.png'
import partner2Src from '../data/images/about-page/cs/slezska-uni.png'
import partner3Src from '../data/images/about-page/cs/ostrava-poruba.png'
import partner4Src from '../data/images/about-page/cs/cesta-von.png'
import partner5Src from '../data/images/about-page/cs/hondotove-vzelavani.png'
import partner6Src from '../data/images/about-page/cs/badatel.png'
import partner7Src from '../data/images/about-page/cs/zs-vlasim.png'
import partner8Src from '../data/images/about-page/cs/zs-svitavy.png'
import partner9Src from '../data/images/about-page/cs/zs-curie.png'
import partner10Src from '../data/images/about-page/cs/val-mezirici.png'


import partnerSk1Src from '../data/images/about-page/sk/ukb.png'
import partnerSk2Src from '../data/images/about-page/sk/nitra.jpg'
import partnerSk3Src from '../data/images/about-page/sk/rcpu.png'
import partnerSk4Src from '../data/images/about-page/edu-spec.png'

import fileIcon from '../data/images/icons/file-icon.svg'

import withExtraction from '../lib/withExtraction'
import { isCs, isSk } from '../lib/appVersions'
import { RichTextContent } from '../components/Card'

const coopImages = [
  {
    src: coop4Src,
    alt: 'OZ Myslenie pre život',
    url: 'https://myslenieprezivot.sk/',
  },
  { src: coop3Src, alt: 'Centrum ROZUM', url: 'https://www.centrumrozum.cz' },
  { src: coop1Src, alt: 'DYS centrum', url: 'http://www.dyscentrum.org' },
]

// na prvn msto dt ATC / Centrum Rozum / DysCentrum
const coopImagesSk = [
  { src: coop5Src, alt: 'ATC', url: 'https://www.a-t-c.cz', width: 200 },
  { src: coop3Src, alt: 'Centrum Rozumu', url: 'https://www.centrumrozum.cz' },
]

const partnersImages = [
  {
    src: partner1Src,
    alt: 'Magistrát hlavního města Prahy',
    url: 'https://praha.eu/web/praha/',
  },
  {
    src: partner2Src,
    alt: 'Slezská univerzita v Opavě',
    url: 'https://www.slu.cz/slu/cz/',
  },
  {
    src: partner3Src,
    alt: 'Úřad městského obvodu Ostrava-Poruba',
    url: 'https://poruba.ostrava.cz/cs',
  },
  { src: partner4Src, alt: 'Cesta Von', url: 'https://cestavon.sk/' },
  {
    src: partner5Src,
    alt: 'Hodnotové vzdělávání Cyril Mooney',
    url: 'https://hvcm.cz/',
  },
  {
    src: partner6Src,
    alt: 'Dítě badatel z.s.',
    url: 'https://www.ditebadatel.com/',
  },
  {
    src: partner7Src,
    alt: 'ZŠ Vorlina Vlašim, p. o.',
    url: 'https://www.zsvorlina.cz/',
  },
  {
    src: partner8Src,
    alt: 'ZŠ Svitavy, T. G. Masaryka 27',
    url: 'https://tgm-svitavy.cz/',
  },
  {
    src: partner9Src,
    alt: 'ZŠ nám. Curieových',
    url: 'https://www.zscurie.cz/',
  },
  {
    src: partner10Src,
    alt: 'MŠ, ZŠ, SŠ pro sluchově postižené, Valašské Meziříčí, Vsetínská 454',
    url: 'https://val-mez.cz/',
  },
]

const partnersImagesSk = [
  {
    src: partnerSk1Src,
    alt: 'Univerzita Komenského v Bratislave',
    url: 'https://uniba.sk/',
  },
  { src: partnerSk2Src, alt: 'Mesto Nitra', url: 'https://www.nitra.sk/' },
  {
    src: partnerSk3Src,
    alt:
      'Regionálne centrum podpory učiteľov pre okresy Nitra a Zlaté Moravce  (RCPÚ Nitra)',
    url: 'https://www.niceedu.sk/',
    title: 'RCPÚ Nitra',
  },
  {
    src: partnerSk3Src,
    alt: 'Regionálne centrum podpory učiteľov pre okres Trnava (RCPÚ Trnava)',
    url: 'https://www.rcputt.sk/',
    title: 'RCPÚ Trnava',
  },
  {
    src: partnerSk3Src,
    alt:
      'Regionálne centrum podpory učiteľov pre okresy Hlohovec a Piešťany (RCPÚ Piešťany)',
    url: 'https://www.rcpuhcpn.sk/',
    title: 'RCPÚ Piešťany',
  },
  { src: partner5Src, alt: 'EDU-spec', url: ' https://edu-spec.sk/' },
  { src: partner9Src, alt: 'OZ Stará Jedáleň', url: ' https://starajedalen.sk/', width: 160 },
  { src: partnerSk4Src, alt: 'EDU-spec', url: ' https://edu-spec.sk/' },
]

const ImageWrapper = styled.div`
  img {
    width: 140px;
    max-width: 100%;
  }
`

const ImagesRow = ({ data, bp = 500, gap = '40px', itemsPerRow = 100 }) => {
  const rows = []
  for (let i = 0; i < data.length; i += itemsPerRow) {
    rows.push(data.slice(i, i + itemsPerRow))
  }

  // console.log('rows', rows)

  return (
    <>
      {rows.map((row, rowIndex) => (
        <Fragment key={rowIndex}>
          <Row
            width="100%"
            justifyContent="center"
            alignItems="center"
            position="relative"
            responsive
            bp={bp}
          >
            {row.map(({ src, alt, url, width, title }, key) => (
              <Fragment key={key}>
                <ImageWrapper>
                  <Gap gap="15px" mobileGap="0" />
                  <Link
                    asA
                    target="_blank"
                    href={url}
                    title={alt}
                    rel="noopener noreferrer"
                  >
                    <Col alignItems="center">
                      <img src={src} alt={alt} style={{ width }} />
                      <Gap gap="8px" mobileGap="0" />
                      {title && <Text>{title}</Text>}
                    </Col>
                  </Link>
                  <Gap gap="15px" mobileGap="0" />
                </ImageWrapper>
                {key + 1 !== row.length && (
                  <>
                    <Gap gap={gap} mobileGap="20px" />
                    <Line isVertical showAfter={bp} />
                    <Gap gap={gap} mobileGap="20px" />
                  </>
                )}
              </Fragment>
            ))}
          </Row>
        </Fragment>
      ))}
    </>
  )
}

const FilesRow = ({ data }) => (
  <Row wrap="wrap" justifyContent="center">
    {data.map(({ title, file: { publicUrl } }, key) => (
      <Fragment key={key}>
        <a href={publicUrl} target="_blank" rel="noopener noreferrer">
          <Row alignItems="center" padding="10px">
            <img src={fileIcon} alt="file icon" style={{ height: '20px' }} />
            <Gap gap="10px" />
            <Text>{title}</Text>
            <Gap gap="20px" />
          </Row>
        </a>
      </Fragment>
    ))}
  </Row>
)

class About extends React.Component {
  componentDidMount() {}

  render() {
    const {
      location: { pathname },
      intl: { language, t },
      data: { allPeople, allDocuments, topImage },
    } = this.props

    const skTeam = allPeople.filter(({ sortOrder }) => sortOrder < 100)
    const csTeam = allPeople.filter(({ sortOrder }) => sortOrder >= 100)

    return (
      <>
        <SEO title={t('O nás')} pathname={pathname} />

        <HeaderBar>
          <HeaderBar.Content shrink={1}>
            <HeaderBar.Title>
              <T>O nás</T>
            </HeaderBar.Title>
            <HeaderBar.SubTitle>
              <T>kdo jsme, co všechno děláme a s kým spolupracujeme</T>
            </HeaderBar.SubTitle>
          </HeaderBar.Content>
          {/* <HeaderBar.ImageWrapper
            padding="0"
            mobileMaxWidth="500px"
            width="50%"
          >
            <Img fluid={topImage.image.fluid} style={{ width: '100%' }} />
          </HeaderBar.ImageWrapper> */}
        </HeaderBar>

        <SubHeaderBar contentMaxWidth="1168px">
          <SubHeaderBar.Text>
            <RichTextContent>
              {t(
                '<strong>Autorizované tréninkové centrum</strong> metod profesora Reuvena Feursteina vzniklo v listopadu 2015 jako projev snahy skupiny odborníků nabízet a šířit metody profesora Reuvena Feuersteina v českém a slovenském prostředí. Do týmu našeho ATC patří řada ředitelů škol, učitelů, speciálních pedagogů, psychologů, lidí na nejrůznějších jiných pozicích.'
              )}
            </RichTextContent>
          </SubHeaderBar.Text>
          <Gap gap="58px" mobileGap="48px" />
          <SubHeaderBar.Text>
            <RichTextContent>
              {t(
                'Součástí <strong>našeho ATC týmu</strong> jsou všichni, kdo se zasloužili o propagaci Feuersteinových metod a stále v tom pokračují, spolupracují na organizaci nejrůznějších akcí nebo jsou jednoduše podpůrní celému ději v Autorizovaném tréninkovém centru metod prof. Reuvena Feuersteina. <strong>Děkujeme!</strong>'
              )}
            </RichTextContent>
          </SubHeaderBar.Text>
        </SubHeaderBar>

        <Page>
          <PageContent>
            <Col alignItems="center">
              <Gap gap="90px" mobileGap="45px" />

              {isCs && (
                <>
                  <Title.Section>
                    <T>Náš tým</T>
                  </Title.Section>
                  <Gap gap="34px" mobileGap="45px" />
                  <PeopleList allPeople={allPeople} />
                  <Gap gap="142px" />
                </>
              )}

              {isSk && (
                <>
                  <Title.Section>
                    <T>Tím OZ Myslenie</T>
                  </Title.Section>
                  <Gap gap="34px" mobileGap="45px" />
                  <PeopleList allPeople={skTeam} />
                  <Gap gap="142px" />

                  <Title.Section>
                    <T>Tím ATC</T>
                  </Title.Section>
                  <Gap gap="34px" mobileGap="45px" />
                  <PeopleList allPeople={csTeam} />
                  <Gap gap="142px" />
                </>
              )}

              <Title.Section>
                <T>Spolupracujeme</T>
              </Title.Section>
              <Gap gap="40px" />
              <ImagesRow data={isSk ? coopImagesSk : coopImages} />
              <Gap gap="170px" mobileGap="80px" />
              <Title.Section>
                <T>Partneři</T>
              </Title.Section>
              <Gap gap="40px" />
              <ImagesRow
                data={isSk ? partnersImagesSk : partnersImages}
                bp={isSk ? 865 : undefined}
                gap={isSk ? '24px' : '40px'}
                itemsPerRow={!isSk ? 5 : undefined}
              />
              <Gap gap="170px" mobileGap="80px" />
              <Title.Section>
                <T>Výroční zprávy</T>
              </Title.Section>
              <Gap gap="40px" mobileGap="20px" />
              <FilesRow
                data={allDocuments.filter(
                  ({ section }) => section === 'REPORT'
                )}
              />
              <Gap gap="160px" mobileGap="80px" />
              <Title.Section>
                <T>Dokumenty ke stažení</T>
              </Title.Section>
              <Gap gap="40px" mobileGap="20px" />
              <FilesRow
                data={allDocuments.filter(
                  ({ section }) => section === 'DOCUMENT'
                )}
              />
              <Gap gap="160px" mobileGap="80px" />
            </Col>
          </PageContent>
        </Page>
      </>
    )
  }
}

export default injectIntl(withExtraction(About))

export const pageQuery = graphql`
  query {
    topImage: file(relativePath: { eq: "images/about-top.png" }) {
      image: childImageSharp {
        fluid(maxWidth: 660, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    ks {
      allPeople(sortBy: sortOrder_ASC) {
        ...PersonFragment
      }
      allDocuments(sortBy: sortOrder_ASC) {
        ...DocumentFragment
      }
    }
  }
`
